import { useQuery } from 'react-query';
import { IdName } from 'core';
import { useApi } from 'providers';

const useVendors = (name?: string) => {
  const api = useApi();

  return useQuery<IdName[]>(
    ['vendors', api, name],
    async () => {
      if (!name) return []

      const { data } = await api.classification.vendorsList({ name });

      return data;
    },
    { staleTime: Number.POSITIVE_INFINITY },
  );
};

export default useVendors;
